// extracted by mini-css-extract-plugin
export default {"twodContainer":"styles_twodContainer__i80m7"};